import { useState } from 'react';

/**
 * La barre de gauche repliée en rail d'icônes, ou dépliée (chantier `barre-repliable`, décision
 * d'Igor du 2026-10-22). Une commodité de cet appareil : gardée dans le navigateur, jamais au
 * serveur ; si le navigateur refuse (navigation privée, stockage bloqué), la barre s'ouvre dépliée
 * et le choix vaut pour la visite.
 */

const CLE = 'nextilt-barre-repliee';

function lireLaBarreRepliee(): boolean {
  try {
    return window.localStorage.getItem(CLE) === 'oui';
  } catch {
    return false;
  }
}

function garderLaBarreRepliee(repliee: boolean): void {
  try {
    window.localStorage.setItem(CLE, repliee ? 'oui' : 'non');
  } catch {
    // Rien à garder : la prochaine visite, dépliée.
  }
}

export function useBarreRepliee(): [boolean, () => void] {
  const [repliee, setRepliee] = useState(lireLaBarreRepliee);
  const basculer = () => {
    garderLaBarreRepliee(!repliee);
    setRepliee(!repliee);
  };
  return [repliee, basculer];
}
